import { render, staticRenderFns } from "./ProductInfoBlock.vue?vue&type=template&id=3fab5b6a&"
import script from "./ProductInfoBlock.vue?vue&type=script&lang=js&"
export * from "./ProductInfoBlock.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfoBlock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VIcon,VRow})
